// "Update Lead Data by NeTRA ID" never changes status or QA fields (Backlog #223,
// 2026-10-23). The backend reports the columns it deliberately ignored; this splits them
// into the ones the PM was probably counting on (status / QA override columns) and the
// harmless identifier columns that come along with an export.
export function summarizeIgnoredColumns(result) {
  const cols = (result && result.ignored_columns) || [];
  return {
    statusColumns: cols.filter(c => c.kind === 'status').map(c => c.column),
    identifierColumns: cols.filter(c => c.kind === 'identifier').map(c => c.column),
    note: (result && result.ignored_note) || null,
  };
}
